(() => {
  const aliases={
    MainContent:'accueil',main:'accueil',benefits:'decloisonner',method:'annuaire-outil-de-ciblage',
    data:'donnees',resources:'ressources',reviews:'avis',offer:'annuaire',faq:'questions',
    preview:'consulter-gratuitement',xali:'emailer',media:'pack-medias'
  };
  const modals=['consulter-gratuitement','acheter-annuaire','guide','emailer','pack-medias','outil-de-ciblage'];
  function resolve(hash){
    const name=hash.replace(/^#/,'');
    if(name==='MainContent')return '#accueil';
    const old=name.match(/^psp-(?:app-)?(main|benefits|method|data|resources|reviews|offer|faq|preview|xali|media)(?:-.*)?$/);
    return old?'#'+aliases[old[1]]:hash;
  }
  function update(hash,replace=false){
    const url=new URL(window.location.href);
    url.hash=hash;
    if(url.href!==window.location.href)window.history[replace?'replaceState':'pushState'](window.history.state,'',url);
  }
  function clear(hash){
    if(resolve(window.location.hash)===hash)update('',true);
  }
  const api={resolve,update,clear,modals};
  if(typeof module==='object'&&module.exports)module.exports=api;
  else window.PSPHomeLinks=api;
})();
